import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/periodos-de-nominas-detalles';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: true,
  });
  return [formattedValues, config];
};

/**
 * GET Periodos De Nominas Detalles
 * @param {object} params
 * @param {object} [options]
 * @param {boolean} [options.silent403] - no mostrar el aviso de "sin permiso" si la
 *   respuesta es 403 (uso: precarga en segundo plano de una pestaña secundaria, donde
 *   el usuario no pidió explícitamente este dato -- otros errores sí se siguen avisando).
 * @returns {Promise<object[]>}
 */
export const getPeriodosDeNominasDetalles = async (params, options = {}) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data?.results || response.data || [];
  } catch (err) {
    if (!(options.silent403 && err?.response?.status === 403)) onError(err);
  }
  return [];
};

/**
 * GET Periodo De Nomina Detalle
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPeriodoDeNominaDetalle = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Periodo De Nomina Detalle
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPeriodoDeNominaDetalle = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Periodo De Nomina Detalle
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPeriodoDeNominaDetalle = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Periodo De Nomina Detalle
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePeriodoDeNominaDetalle = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
